import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: "contacts",
    data() {
        return {}
    },
    created() {

    },
    computed: {
        ...mapGetters({
            contactsContent:'home/contactsContent'
        })
    },

    methods: {
        ...mapMutations({}),
        ...mapActions({})
    }
}
